export default __webpack_public_path__ + "static/media/beer.0af4207f.jpg";